import React from "react";
import EditorNavigationButtons from "./EditorNavigationButtons";

interface SelfProps {
    currentStep: string,
    currentStepIndex: number,
    onPreviousStepButtonClick: any,
    onNextStepButtonClick: any,
    activeAvailableSteps: any[],
    nextButtonAvailable: boolean
}

export default class StepNavigationButtons extends React.Component<SelfProps> {
    isOnLastStep() {
        return this.props.currentStepIndex === this.props.activeAvailableSteps.length - 1
    }

    onNextStepButtonClick = () => {
        if (this.isOnLastStep()) {
            return
        }

        this.props.onNextStepButtonClick();
    }

    render() {
        const previousButtonAvailable = this.props.currentStepIndex > 0;
        const nextButtonAvailable = this.props.nextButtonAvailable;
        const props = {
            currentStep: this.props.currentStep,
            onPreviousStepButtonClick: this.props.onPreviousStepButtonClick,
            onNextStepButtonClick: this.onNextStepButtonClick,
            isPreviousButtonActive: previousButtonAvailable,
            isNextButtonActive: nextButtonAvailable,
            isOnLastStep: this.isOnLastStep(),
        }

        return (
            <React.Fragment>
                <EditorNavigationButtons {...props}/>
            </React.Fragment>
        )

    }
}